import { BaseApi, ApiResponse } from "../utils/request";

// 充值配置相关类型定义
export interface RechargeConfigRequest {
  [key: string]: any;
}

// 支付方式项
export interface PayMethodItem {
  method: string; // 支付方式代码，如 "GCASH"
  name: string; // 支付方式名称，如 "Gcash"
  enabled: boolean; // 是否启用
  icon?: string; // 图标URL（可选）
  [key: string]: any;
}

export interface RechargeConfigResponse {
  status: number;
  message?: string;
  data?: {
    payMethodItemVOS?: PayMethodItem[]; // 支付方式列表
    amountList?: number[]; // 充值金额列表
    minAmount?: number; // 最小充值金额
    maxAmount?: number; // 最大充值金额
    currencies?: Array<{
      id: string;
      name: string;
      symbol: string;
      rate: number;
    }>;
    promotions?: Array<{
      id: string;
      title: string;
      description: string;
      bonusRate?: number;
      maxBonus?: number;
      validUntil?: string;
    }>;
    [key: string]: any;
    firstRuleList?: Array<{
      id: string;
      amount: number;
      promoRatio: number;
      promoAmount?: number;
      onlyAuditPromoAmount?: number;
      auditRatio?: number;
      realAuditRatio?: number;
    }>;
  };
  time?: number;
  maxAge?: number;
  [key: string]: any;
}

/**
 * 充值 API 类
 * 继承 BaseApi，提供充值相关的 API 接口
 */
export class DepositApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 获取充值配置
   * @param data 请求参数
   * @returns Promise<ApiResponse<RechargeConfigResponse>>
   */
  async getRechargeConfig(
    data: RechargeConfigRequest = {}
  ): Promise<ApiResponse<RechargeConfigResponse>> {
    return this.post<RechargeConfigResponse>("/api/pay/recharge_config", data);
  }
}

export const depositApi = new DepositApi();

// 便捷方法
export const getRechargeConfig = (data?: RechargeConfigRequest) =>
  depositApi.getRechargeConfig(data);
